export default __webpack_public_path__ + "static/media/personalChitCalendar_sample.8e3c3142.jpg";